import React, { useState } from 'react'

import {
  Paper,
  Box,
  Typography,
  Switch,
  Grid,
  TextField,
  Button,
} from '@material-ui/core'

import { Alert } from '@material-ui/lab'

import useSnackbar from 'hooks/useSnackbar'
import useAssignmentPermission from 'hooks/useAssignmentPermission'
import useAuth from 'hooks/useAuth'

import { ActivityDisputeDai } from '../ActivityManageForm/components'

import * as service from 'service'
import helpers from 'helpers'
import constants from 'constants/index'

const Contestation = ({
  activity,
  governanceProjectId,
  contesting,
  setContesting,
  contestationText,
  setContestationText,
  refresh,
  activityName,
  earlyAccess,
}) => {
  const contestationDisabled =
    !activity?.governanceProject?.underContestation ||
    (!!activity?.stageContestation &&
      activity?.stageContestation?.status !==
        constants.governanceProjectStages.AWAITING_REVIEW_STAGE_STATUS)

  const {
    isManager,
    isProjectResponsible,
    isAreaResponsible,
    isActivityResponsible,
  } = useAssignmentPermission({
    governanceProject: activity?.governanceProject,
  })

  const snackbar = useSnackbar()
  const { user } = useAuth()

  const [loading, setLoading] = useState(false)

  const isInternalUser =
    user?.email?.endsWith('@dponet.com.br') ||
    user?.email?.endsWith('@leavening.com')

  const showDisputeAnalysis =
    isInternalUser ||
    (helpers.dai.disputeAnalysisEnabled(activity) &&
      !!activity?.daiDisputeResponse?.runId)

  const handleChangeContesting = (event) => {
    setContesting(event.target.checked)
  }

  const question = activity?.governanceProjectQuestion

  const handleSave = async () => {
    try {
      setLoading(true)
      await service.dponet.governanceProjectActivity.contest({
        governanceProjectId,
        id: activity?.id,
        name: question?.question,
        description: contestationText,
      })
      refresh()
      snackbar.open({
        message: 'Contestação enviada com sucesso. Aguarde a análise.',
        variant: 'success',
      })
    } catch (error) {
      snackbar.open({
        message:
          helpers.formatters.errorMessage(error) ||
          'Erro ao enviar contestação',
        variant: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  const canEdit =
    isManager ||
    isProjectResponsible ||
    isAreaResponsible ||
    isActivityResponsible

  return (
    <Grid container spacing={4}>
      {earlyAccess && (
        <Grid item xs={12}>
          <Alert severity="info">
            <Typography>
              A contestação ainda não está disponível para edição pois a questão
              está na etapa de revisão das respostas.
            </Typography>
          </Alert>
        </Grid>
      )}
      {showDisputeAnalysis && (
        <Grid item xs={12}>
          <ActivityDisputeDai
            activity={activity}
            governanceProjectId={governanceProjectId}
            canManageAnalysis={isInternalUser}
          />
        </Grid>
      )}
      <Grid item xs={12}>
        <Paper variant="outlined">
          <Box display="flex" flexDirection="column" p={2} gap={2}>
            <Typography>
              Deseja apresentar uma contestação para esta questão?
            </Typography>
            <Box display="flex" gap={2} alignItems="center">
              <Switch
                name="contestation"
                onChange={handleChangeContesting}
                checked={contesting}
                disabled={contestationDisabled || !canEdit || earlyAccess}
              />
              <Typography>Registrar contestação</Typography>
            </Box>
          </Box>
        </Paper>
      </Grid>
      {contesting && (
        <Grid item xs={12}>
          <Paper variant="outlined">
            <Box display="flex" flexDirection="column" p={2} gap={2}>
              <Typography variant="h4" gutterBottom>
                {activityName}
              </Typography>
              <Typography variant="h6">{question?.question}</Typography>
            </Box>

            <Box display="flex" flexDirection="column" p={2} gap={2}>
              <Typography variant="h6" color="textSecondary" gutterBottom>
                Contestação
              </Typography>
              <TextField
                placeholder="Descreva sua contestação aqui..."
                variant="outlined"
                onChange={(event) => setContestationText(event.target.value)}
                minRows={15}
                value={contestationText}
                multiline
                disabled={contestationDisabled || !canEdit || earlyAccess}
                fullWidth
              />
              {!contestationDisabled && !earlyAccess && (
                <Box display="flex" justifyContent="flex-end">
                  <Button
                    disabled={loading || !canEdit}
                    variant="contained"
                    color="primary"
                    onClick={handleSave}
                  >
                    Salvar
                  </Button>
                </Box>
              )}
            </Box>
          </Paper>
        </Grid>
      )}
    </Grid>
  )
}

export default Contestation
